// extracted by mini-css-extract-plugin
module.exports = {"container":"_424493e","visuallySimilarWrapper":"_d7527c6a"};